import { jsx } from 'react/jsx-runtime';
import FocusTrap from 'focus-trap-react';

const withFocusTrap = (children) => () => (jsx(FocusTrap, { children: children }));

export { withFocusTrap };
